import { combineReducers } from 'redux';

import { userReducer } from './user/reducer';
import { companyReducer } from './company/reducer';
import { wcoxmlwebReducer } from './wcoxmlweb/reducer';
import { authReducer } from './auth/reducer';
import { settingsReducer } from './settings/reducer';

export const rootReducer = combineReducers({
  user: userReducer,
  company: companyReducer,
  wcoxmlweb: wcoxmlwebReducer,
  auth: authReducer,
  settings: settingsReducer,
});
